import { useMemo } from 'react'
import { Outlet, useLocation, useNavigate, useParams } from 'react-router'
import clsx from 'clsx'
import { useMediaQuery } from '@mantine/hooks'
import Tabs from '../stories/Tabs/Tabs'
import Meta from '../common/Meta'
import classes from './Races.module.css'
import { useRaceDetails } from './api'
import { IconChevronLeft } from '@tabler/icons-react'
import RaceHeader from '../common/components/header/RaceHeader'

export default function RaceDetailsLayout() {
  const { competitionId, raceId } = useParams()
  const navigate = useNavigate()
  const location = useLocation()
  const isDesktop = useMediaQuery('(min-width: 800px)')

  const { data: race } = useRaceDetails({
    competition_id: Number(competitionId),
    race_id: Number(raceId),
  })

  const activeTab = useMemo(() => {
    const path = location.pathname
      .split('/races/')[1]
      ?.split('/')
      .slice(1)
      .join('/')
    return path ?? ''
  }, [location.pathname])

  const tabs = useMemo(() => {
    const baseTabs = [{ value: 'summary', label: 'Race Summary' }]
    if (race.video?.main) {
      baseTabs.push({
        value: 'highlights',
        label: 'Watch Race',
      })
    }
    return baseTabs
  }, [race.video?.main])

  return (
    <div className={classes.container}>
      <Meta title={`Race ${race.round_number}`} />
      <div className={classes.headerContainer}>
        {isDesktop && (
          <IconChevronLeft
            onClick={() => navigate(-1)}
            className={classes.backIcon}
          />
        )}
        <RaceHeader race={race} />
      </div>
      <div
        className={clsx(classes.raceDetailsContainer, {
          [classes.raceDetailsContainerMobile]: !isDesktop,
        })}
      >
        <div className={classes.raceDetailsWrapper}>
          <div
            className={clsx(classes.raceTabs, {
              [classes.raceTabsMobile]: !isDesktop,
            })}
          >
            <Tabs items={tabs} value={activeTab} onChange={() => {}} isLink />
          </div>
          <Outlet />
        </div>
      </div>
    </div>
  )
}
